"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Dialog = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const web_sds_c_1 = require("@snapchat/web-sds-c");
const react_1 = require("react");
const GhostIcon_1 = require("../../icons/GhostIcon");
const Dialog_module_css_1 = __importDefault(require("./Dialog.module.css"));
const web_env_1 = require("@snapchat/web-env");
/**
 * Generic full player takeover modal
 */
function Dialog({ children, secondaryAction, secondaryLabel, primaryLabel, primaryAction, closeDialog, }) {
    const dialogRef = (0, react_1.useRef)(null);
    // close dialog if user clicks outside the container
    (0, react_1.useEffect)(() => {
        const handlePageClick = (event) => {
            const target = event.target;
            if (dialogRef.current && !dialogRef.current.contains(target)) {
                closeDialog();
            }
        };
        // add event listener on the next loop, so the dialog is not closed as it renders
        process.nextTick(() => {
            typeof (0, web_env_1.getWindow)() !== "undefined" && (0, web_env_1.getWindow)()?.addEventListener("click", handlePageClick);
        });
        return () => {
            typeof (0, web_env_1.getWindow)() !== "undefined" &&
                (0, web_env_1.getWindow)()?.removeEventListener("click", handlePageClick);
        };
    }, [closeDialog]);
    const renderActionButtons = () => ((0, jsx_runtime_1.jsxs)("div", { className: Dialog_module_css_1.default.actionButtons, "data-testid": "dialogActionButton", children: [secondaryAction && (0, jsx_runtime_1.jsx)(web_sds_c_1.PrimaryButton, { onClick: secondaryAction, children: secondaryLabel }), (0, jsx_runtime_1.jsx)(web_sds_c_1.PrimaryButton, { onClick: primaryAction, children: primaryLabel })] }));
    return ((0, jsx_runtime_1.jsx)("div", { className: Dialog_module_css_1.default.container, children: (0, jsx_runtime_1.jsxs)("div", { ref: dialogRef, className: Dialog_module_css_1.default.innerContainer, children: [(0, jsx_runtime_1.jsx)("div", { className: Dialog_module_css_1.default.ghostIconWrapper, children: (0, jsx_runtime_1.jsx)(GhostIcon_1.GhostIcon, {}) }), (0, jsx_runtime_1.jsx)("div", { className: Dialog_module_css_1.default.content, "data-testid": "dialogContent", children: children }), renderActionButtons()] }) }));
}
exports.Dialog = Dialog;
//# sourceMappingURL=Dialog.js.map